import { motion } from "framer-motion";
import { ChapterHeading } from "./ChapterHeading";
import { useLang } from "../lib/i18n";

export const Method = () => {
  const { t } = useLang();
  const steps = t("method.steps");
  return (
    <section id="method" data-testid="method-section" className="bg-cream py-28 md:py-40">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <ChapterHeading number="03" title={t("method.title")} />
        <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-px bg-ink/15 border border-ink/15">
          {steps.map(([n, title, body], i) => (
            <motion.div key={n} data-testid={`method-step-${i}`}
              initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: "easeOut" }}
              className="bg-cream p-8 md:p-10 group hover:bg-[#ede7d9] transition-colors duration-500">
              <div className="font-display text-6xl md:text-7xl text-transparent transition-colors duration-500"
                style={{ WebkitTextStroke: "1px rgba(12,44,37,0.35)" }}>
                <span className="group-hover:text-gold transition-colors duration-500" style={{ WebkitTextStroke: "0px" }}>{n}</span>
              </div>
              <h3 className="font-display text-2xl text-ink mt-8">{title}</h3>
              <p className="mt-4 text-sm text-ink/60 leading-relaxed">{body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
